package org.gymly.util

actual val portalApiPrefix: String = "/api/portal"
